import React from 'react';
import PropTypes from 'prop-types';

import Tile from '@shared/propTypes/Tile';

import PackageDetailsModal from '@/v2/components/ui/PackageDetailsModal/PackageDetailsModal';

const ProcuredOfferModal = ({
  onClose,
  tile,
  showHotelTerms = false,
  inclusions,
}) => {
  const { procuredOffer, propertyContent } = tile;

  const { terms, hotelTerms } = procuredOffer;

  const { destination, name } = propertyContent;

  return (
    <PackageDetailsModal
      onClose={onClose}
      destinationName={destination.title}
      propertyName={name}
      terms={terms}
      hotelTerms={showHotelTerms && hotelTerms}
      inclusions={
        inclusions || procuredOffer.rooms[0].leadInOffers[0]?.inclusions
      }
    />
  );
};

ProcuredOfferModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  tile: Tile.isRequired,
  showHotelTerms: PropTypes.bool,
};

export default ProcuredOfferModal;
